import VerticalMenu from '~/themes/base/components/shop/VerticalMenu'

export default {
  extends: VerticalMenu,
}
